import { render, staticRenderFns } from "./MessageTable.vue?vue&type=template&id=2435fb80"
import script from "./MessageTable.vue?vue&type=script&lang=js"
export * from "./MessageTable.vue?vue&type=script&lang=js"
import style0 from "./MessageTable.vue?vue&type=style&index=0&id=2435fb80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports